// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flexNews {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.newsBackground {
    background: lightblue;
}

.boxCard {
    padding: 20px;
    justify-content: center;
    border-radius: 1rem;
    box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);
    width: 60%;
    margin-bottom: 1.5rem;
}

@media(max-width:500px) {
    .boxCard {
        width: 90%;
    }
}

.iconPosition {
    display: block;
    text-align: end;
}

.boxAddNews {
    margin-left: 20%;
    margin-right: 20%;
    width: 60%;
}

.buttonAddNew {
    background-color: white;
    color: black;
    border-radius: 10em;
    font-size: 14px;
    font-weight: 600;
    padding: 1em 2em;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    border: 1px solid black;
    box-shadow: 0 0 0 0 black;
}

.buttonAddNewPositon {
    display: flex;
    justify-content: center;
    padding: 1em 0em;
}

.buttonAddNew:hover {
    transform: translateY(-4px) translateX(-2px);
    box-shadow: 2px 5px 0 0 black;
}

.buttonAddNew:active {
    transform: translateY(2px) translateX(1px);
    box-shadow: 0 0 0 0 black;
}

.boxImg {
    display: flex;
    justify-content: center;
}

.imgNews {
    max-width: 80%;
    max-height: 70vh;
}

@media(max-width:480px){
    .imgNews{
        width: 90%;
        height: 90%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/News/news.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,+CAA+C;IAC/C,uDAAuD;IACvD,oDAAoD;IACpD,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,6BAA6B;AACjC;;AAEA;IACI,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;QACV,WAAW;IACf;AACJ","sourcesContent":[".flexNews {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.newsBackground {\n    background: lightblue;\n}\n\n.boxCard {\n    padding: 20px;\n    justify-content: center;\n    border-radius: 1rem;\n    box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);\n    -webkit-box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);\n    -moz-box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);\n    width: 60%;\n    margin-bottom: 1.5rem;\n}\n\n@media(max-width:500px) {\n    .boxCard {\n        width: 90%;\n    }\n}\n\n.iconPosition {\n    display: block;\n    text-align: end;\n}\n\n.boxAddNews {\n    margin-left: 20%;\n    margin-right: 20%;\n    width: 60%;\n}\n\n.buttonAddNew {\n    background-color: white;\n    color: black;\n    border-radius: 10em;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 1em 2em;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    border: 1px solid black;\n    box-shadow: 0 0 0 0 black;\n}\n\n.buttonAddNewPositon {\n    display: flex;\n    justify-content: center;\n    padding: 1em 0em;\n}\n\n.buttonAddNew:hover {\n    transform: translateY(-4px) translateX(-2px);\n    box-shadow: 2px 5px 0 0 black;\n}\n\n.buttonAddNew:active {\n    transform: translateY(2px) translateX(1px);\n    box-shadow: 0 0 0 0 black;\n}\n\n.boxImg {\n    display: flex;\n    justify-content: center;\n}\n\n.imgNews {\n    max-width: 80%;\n    max-height: 70vh;\n}\n\n@media(max-width:480px){\n    .imgNews{\n        width: 90%;\n        height: 90%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
